﻿(function () {
    const skipNavigationLink = document.querySelector('.skip-navigation-button__link');
    const main = document.querySelector('main');
    const myPagesContainer = document.querySelector('#MyPages-container');
    const skipToElement = myPagesContainer || main;
    if (!skipToElement && skipNavigationLink) [
        skipNavigationLink.remove()
    ]
    else if (skipToElement && skipNavigationLink) {
        skipNavigationLink.setAttribute('href', `#${skipToElement.id}`);
        skipNavigationLink.addEventListener('click', function (evt) {
            evt.preventDefault();
            window.LBSApp.FocusUtils.focusAndAdjust(skipToElement);
        });
    }
}())